import { WeekdayOrdinal } from '../../../features/calendar/calendar-types';
import { TodoContainerDirective } from '../../../features/todo-planner/directives/todo-container.directive';
import { TodoEntryWrapperDirective } from '../../../features/todo-planner/directives/todo-entry-wrapper.directive';
import { TodoPlannerViews } from '../../../features/todo-planner/utils/todo-planner-types';
import { UserModel } from '../user/user.model';
import { TodoEntryModel } from './todo-entry.model';

export class BaseTodoPlannerModel {
  // Container and slots
  public fixIntervalTodoWrapper: TodoEntryWrapperDirective[] = []; // Wrapper for the slots.
  public fixIntervalTodoContainer: TodoContainerDirective[] = [];
  public variableIntervalTodoWrapper: TodoEntryWrapperDirective[] = []; // Wrapper for the slots.
  public variableIntervalTodoContainer: TodoContainerDirective[] = [];
  public fixIntervalTodoEntryModels = new Map<string, TodoEntryModel[]>();
  public variableIntervalTodoEntryModels = new Map<string, TodoEntryModel[]>();
  public containerWidth: number = null;

  // Planner config data
  public plannerStart: Date | null = null;
  public plannerEnd: Date | null = null;
  public weekStartsOn: WeekdayOrdinal | null = null;
  public plannerViewMode: TodoPlannerViews | null = null;
  public userId: UserModel | null = null;
  public hideTodoEntryDetails: boolean | null = null;
}
